export default angular.module('ClientStorage', []);
